import { DeliveryPersonDTO, Res } from 'core/api';
import * as React from 'react';
import { AcceptActionButton, Content, Header, PosScreen, Footer, Filler } from 'pos/ui';

import * as Images from 'pos/Images';
import DeliveryPersonStatusList from 'pos/ui/DeliveryPersonList';
import { Modal } from 'core/ui-next/modal';
import { VStack } from '@chakra-ui/react';

type Props = {
	deliveryStatuses: DeliveryPersonDTO[];
	deliveryPersonSelected?: DeliveryPersonDTO;
} & Modal.Actions<DeliveryPersonDTO>;


function SelectDeliveryPerson(props: Props): React.ReactNode {

	const { deliveryStatuses, deliveryPersonSelected, cancel, close } = props;

	const [selectedDeliveryPerson, setSelectedDeliveryPerson] = React.useState<DeliveryPersonDTO>(deliveryPersonSelected ?? deliveryStatuses[0]);

	const onAccept = async () => {
		// Siempre hay alguno seleccionado. Al crearlo se garantiza que se selecciona el primero, y luego
		// no hay forma de quitarlo, sólo de cambiarlo por otro
		close(selectedDeliveryPerson);
	};

	return <PosScreen size={'medium'} screenId={'GET_DELIVERY_PERSON'} useKeyPad={false}>
		<Header title={Res.Web.GET_DELIVERY_PERSON()} image={Images.ChangeDeliveryPerson} onClose={cancel} />
		<Content>
			<VStack padding={6} overflowY={'auto'} height={'full'}>
				<DeliveryPersonStatusList
					deliveryPersons={deliveryStatuses}
					selected={selectedDeliveryPerson}
					onDeliveryPersonSelected={
						(deliveryPerson) => setSelectedDeliveryPerson(deliveryPerson)
					} />
			</VStack>
		</Content>
		<Footer>
			<Filler />
			<AcceptActionButton action={onAccept} />
		</Footer>
	</PosScreen>;
}

export default async function getDeliveryPerson(deliveryPersonStatuses: DeliveryPersonDTO[], deliveryPersonSelected?: DeliveryPersonDTO): Promise<Result<DeliveryPersonDTO>> {
	return Modal.show(SelectDeliveryPerson, { deliveryStatuses: deliveryPersonStatuses, deliveryPersonSelected });
}